import React, { useState } from 'react';
import { Button } from './ui/Button';
import { MenuIcon, XIcon } from 'lucide-react';
import { LogoIcon } from './LogoIcon';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    href: '#engine',
    label: 'Engine'
  }, {
    href: '#pwa',
    label: 'PWA Riešenia'
  }, {
    href: '#portfolio',
    label: 'Portfólio'
  }, {
    href: '#interiorai',
    label: 'InteriorAI'
  }, {
    href: '#kontakt',
    label: 'Kontakt'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100/80" data-id="element-326">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-327">
        <div className="flex justify-between items-center h-16" data-id="element-328">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-329">
            <a href="#" className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-300" data-id="element-330">
              <LogoIcon size={40} data-id="element-331" />
              <span className="text-lg font-bold tracking-tight text-apple-black hidden sm:inline" data-id="element-332">
                Larsen Evans
              </span>
            </a>
          </div>

          {/* Desktop Navigation Links */}
          <nav className="hidden md:flex space-x-8" data-id="element-333">
            {links.map(link => <a key={link.href} href={link.href} className="relative text-sm font-medium text-apple-black hover:text-apple-blue transition-colors duration-300 py-1 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-apple-blue after:transition-all after:duration-300 hover:after:w-full" data-id="element-334">
                {link.label}
              </a>)}
            <a href="https://cloud-sparkle-nexus.lovable.app" target="_blank" rel="noopener noreferrer" className="relative text-sm font-semibold text-apple-blue hover:text-apple-blueHover transition-colors duration-300 py-1 flex items-center gap-1.5 after:absolute after:bottom-0 after:left-0 after:w-0 after:h-0.5 after:bg-apple-blue after:transition-all after:duration-300 hover:after:w-full" data-id="element-335">
              ☁️ Cloud LE/AI
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-336">
            <Button size="small" className="!bg-apple-blue hover:!bg-apple-blueHover !text-white !rounded-full !px-5 !border-none !font-semibold btn-hover-premium" data-id="element-337">
              Začať Projekt
            </Button>
          </div>

          {/* Mobile Hamburger Button */}
          <div className="md:hidden flex items-center" data-id="element-338">
            <button onClick={() => setIsOpen(!isOpen)} className="p-2 text-apple-black focus:outline-none" aria-label="Toggle menu" data-id="element-339">
              {isOpen ? <XIcon className="w-6 h-6" data-id="element-340" /> : <MenuIcon className="w-6 h-6" data-id="element-341" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out bg-white/95 backdrop-blur-xl ${isOpen ? 'max-h-96 border-b border-gray-100' : 'max-h-0'}`} data-id="element-342">
        <nav className="flex flex-col px-4 pt-2 pb-6 space-y-2" data-id="element-343">
          {links.map(link => <a key={link.href} href={link.href} onClick={() => setIsOpen(false)} className="block px-4 py-3 text-base font-medium text-apple-black hover:bg-gray-50 rounded-lg transition-colors" data-id="element-344">
              {link.label}
            </a>)}
          <a href="https://cloud-sparkle-nexus.lovable.app" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)} className="block px-4 py-3 text-base font-semibold text-apple-blue hover:bg-blue-50 rounded-lg transition-colors" data-id="element-345">
            ☁️ Cloud LE/AI
          </a>
          <div className="px-4 pt-4" data-id="element-346">
            <Button size="large" className="w-full !bg-apple-blue hover:!bg-apple-blueHover !text-white !rounded-full !border-none !font-semibold" data-id="element-347">
              Začať Projekt
            </Button>
          </div>
        </nav>
      </div>
    </header>;
}